module.exports = "/_next/static/images/punctuality-illustration-e4d0b3126ec9ad91ea419d65d7ffde81.svg";